if (!customElements.get('text-animation')) {
  customElements.define(
    'text-animation',
    class TextAnimation extends HTMLElement {
      constructor() {
        super();
        document.addEventListener('DOMContentLoaded', () => {
          this.prefersReducedMotion =
            window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

          this.animationType = this.dataset.animation;

          this.init();
        });
      }

      init() {
        if (this.prefersReducedMotion) return;
        switch (this.animationType) {
          case 'typing':
            this.initTyping();
            break;
        }
      }

      initTyping() {
        const typingSpeed = Number(this.dataset.typingSpeed) || 50;
        const initialDelay = Number(this.dataset.typingInitialDelay) || 0;
        const pauseDuration = Number(this.dataset.typingPause) || 2000;
        const deletingSpeed = Number(this.dataset.typingDeletingSpeed) || 30;

        const showCursor = this.dataset.typingShowCursor === 'true';

        const cursorChar = this.dataset.typingCursor || '|';

        const originalText = this.textContent.trim();
        let displayedText = '';
        let index = 0;
        let deleting = false;

        const contentSpan = document.createElement('span');
        contentSpan.className = 'typing-content';

        const cursorSpan = document.createElement('span');
        cursorSpan.className = 'typing-cursor';
        cursorSpan.textContent = cursorChar;

        this.textContent = '';
        this.appendChild(contentSpan);
        if (showCursor) this.appendChild(cursorSpan);

        const tick = () => {
          const hideCursorWhileTyping = this.dataset.typingHideCursor === 'true';
          if (!deleting) {
            if (index < originalText.length) {
              if (index === 0 && hideCursorWhileTyping && showCursor) {
                cursorSpan.classList.add('cursor-hidden');
              }

              displayedText += originalText[index++];
              contentSpan.textContent = displayedText;

              setTimeout(tick, typingSpeed);
            } else {
              if (hideCursorWhileTyping && showCursor) {
                cursorSpan.classList.remove('cursor-hidden');
              }

              setTimeout(() => {
                deleting = true;
                tick();
              }, pauseDuration);
            }
          } else {
            if (displayedText.length) {
              displayedText = displayedText.slice(0, -1);
              contentSpan.textContent = displayedText;

              setTimeout(tick, deletingSpeed);
            } else {
              deleting = false;
              index = 0;

              setTimeout(tick, pauseDuration);
            }
          }
        };

        setTimeout(tick, initialDelay);
      }
    },
  );
}
